import ProjectInvoice from './project-invoice';
import Company from '../company/company';
import CustomProductInvoicePrice from './custom-product-invoice-price';

export default class PlacementInvoice extends ProjectInvoice {
  customProductInvoicePrices?: CustomProductInvoicePrice[];

  constructor(company?: Company) {
    super(company);
    this.type = 'PlacementInvoice';
  }
}
